import { useState } from "react";
import { useLocation } from "react-router-dom";
import { AppShell, Burger, Group, Text, Button, Stack, Title } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useDispatch, useSelector } from "react-redux";
import { clearTokens } from "../../../redux/reducers/authSlice";
import { IconChevronRight, IconLogout } from "@tabler/icons-react";
import { selectUserInfo } from "../../../redux/selectors/authSelector";
import Navbar from "./navbar/navbar";
import { selectMaintenanceMode } from "../../../redux/selectors/settingSelector";

const Skeleton = ({ children }: { children: React.ReactNode }) => {
  const [opened, { toggle }] = useDisclosure();
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector(selectUserInfo);
  const location = useLocation();
  const pathName = location.pathname.split('/')?.pop();
  const maintenanceMode = useSelector(selectMaintenanceMode);

  return (
    <AppShell
      layout="alt"
      header={{ height: 60 }}
      footer={{ height: 60 }}
      navbar={{ width: collapsed ? 100 : 200, breakpoint: "sm", collapsed: { mobile: !opened } }}
      padding="md"
      styles={{
        main: {
          backgroundColor: "#fdfdfd",
        },
        header: {
          color: "#243c6f",
        },
        navbar: {
          color: "#243c6f",
        },
      }}
    >
      <AppShell.Header>
        <Group h="100%" px="md">
          <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
          <Text fw={700} fz={22}>{(pathName?.charAt(0)?.toUpperCase() || '') + pathName?.slice(1).toLowerCase()} Page</Text>
          <Text style={{ marginLeft: 'auto' }}>Welcome, {user?.first_name}</Text>
        </Group>
        {window.location.host.includes('heroku') && <Group justify="center" bg="red" mt="-15px">
          <Text>WARNING: This is a test environment. Changes here do NOT reflect the real environment.</Text>
        </Group>}
        {maintenanceMode && <Group justify="center" bg="red" mt="-5px">
          <Text fw={700} fz={18}>The website is under maintenance. DO NOT EXECUTE ANY CHANGES.</Text>
        </Group>}
      </AppShell.Header>
      <AppShell.Navbar p="md">
        <Stack justify="space-between" h="100%">
          <Group gap="0">
            <Group mb="md">
              <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
              <Title order={3} ta="center" style={{ borderBottom: '1px solid #243c6f', paddingBottom: '15px' }}>{collapsed ? 'TGWS' : 'The Greek Wedding Show'}</Title>
            </Group>
            <Navbar />
          </Group>
          <Stack>
            <Button onClick={() => { setCollapsed(!collapsed) }} variant="outline">
              {collapsed ? <IconChevronRight /> : 'Collapse'}
            </Button>
            <Button onClick={() => { dispatch(clearTokens()) }}>
              {collapsed ? <IconLogout /> : 'Logout'}
            </Button>
          </Stack>
        </Stack>

      </AppShell.Navbar>
      <AppShell.Main>{children}</AppShell.Main>
      <AppShell.Footer p="md">
        <Text fw={400} fz={14} ta="center">The Greek Wedding Show 2025</Text>
      </AppShell.Footer>
    </AppShell>
  );
};

export default Skeleton;
